import { OptionItem } from 'tno-core';

export const labelOptions = [
  new OptionItem('Person', 'Person'),
  new OptionItem('Organization', 'Organization'),
  new OptionItem('Location', 'Location'),
  new OptionItem('Date', 'Date'),
  new OptionItem('Time', 'Time'),
  new OptionItem('Money', 'Money'),
];
